// Polyfill
import "@node_modules/core-js/stable";
import "@node_modules/regenerator-runtime/runtime";

// Libs
import Vue from 'vue'
import VueI18n from '@node_modules/vue-i18n'
import Vuex from '@node_modules/vuex'
import { mapGetters, mapState, mapActions } from '@node_modules/vuex';

// Legacy Libs
import '@base_js/base.js'
import { script } from '@base_js/script'

// Store
import store  from '@store';

// Mixins
import InitMixin from '@mixins/init_mixin';
import LegacyBridgeMixin from '@mixins/legacy_bridge_mixin';


// Directives
import MagnificPopupDirective from '@directives/magnific_popup_link';

// LESS
import '@less/sdg_detail.less'

// Assets
import '@images/arrow.svg'
import '@images/x.svg'

// Application components
import SDGList from '@components/sdg_list'
import Hero from '@components/hero'

Vue.use(VueI18n)
Vue.use(Vuex)

Vue.directive('magnific-popup', MagnificPopupDirective)

const i18n = new VueI18n({
  locale: "curr",
  messages
})

// Application instance
const vueInstance = new Vue({
  store,
  i18n,
  mixins: [
  	InitMixin,
    LegacyBridgeMixin
  ],
  el: '#app-root',
  components: {
    'sdg-list': SDGList,
    Hero
  },
  methods: {
	  ...mapActions('sdgDetail', [
	    'loadItems',
      'setCurrentPage'
	  ])
	},
  computed: {
    ...mapState('sdgDetail', [
      'sdgIdentifier',
      'sdgNumProjects',
      'count',
      'sdgCommunity',
      'sdgRaised',
      'currentPage'
    ])
  },
  async mounted () {
    console.log('mounted')
    try{
      let resp = await this.loadItems()
      this.setCurrentPage(0)  
    }catch(err){
      console.log(err)
    }
  }
})


